import { render } from "./AppLayout.vue?vue&type=template&id=3115bfb6"
import script from "./AppLayout.vue?vue&type=script&lang=ts"
export * from "./AppLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script